import React from 'react';
import {useTranslation} from 'react-i18next';


function Input(props) {
	const {t} = useTranslation();
	let {
		label = '',
		name = '',
		placeholder = '',
		required = false,
		updateItem = () => {
		},
		item = {},
		isError = false,
		img = (null),
		display = {}
	} = props;

	let paramsInput = {
		placeholder
	}
	let classNames = [];

	if (isError) {
		classNames.push('is-invalid');
	}

	return (
		<div className="mb-3">
			{
				(
					(typeof display.label === 'undefined') ||
					(typeof display.label !== 'undefined' && display.label)
				) && label && (
					<label className="form-label">
						{label} {required && (<span>*</span>)}
					</label>
				)
			}
			{img && (<img src={img} />)}
			<input
				className={'form-control ' + classNames.join(' ')}
				value={typeof item[name] !== 'undefined' ? item[name] : ''}
				onChange={(evt) => {
					updateItem(name, evt.target.value);
				}}
				{...paramsInput}
			/>
			{isError !== false && (<div className="invalid-feedback">{t('Form.' + isError)}</div>)}
		</div>
	);
}

export default Input;
